// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.86.1',
  revision: '0503d003c',
  branch: 'master',
  date: 'Thu, 12 Mar 2026 13:43:19 GMT'
};